<template>
	<div class="workingHours">

		<el-row type="flex" class="row-bg" justify="center">
			<el-col :xs="7" :sm="2" :md="2" :lg="2" :xl="2">
				<div class="title">
					上班时间
				</div>
			</el-col>
			<el-col :xs="17" :sm="10" :md="10" :lg="10" :xl="10">
				<div class="block">
					<el-time-picker v-model="data.startTime" format="HH:mm" value-format="HH:mm">
					</el-time-picker>
				</div>
			</el-col>
		</el-row>

		<el-row type="flex" class="row-bg row-bg-1" justify="center">
			<el-col :xs="7" :sm="2" :md="2" :lg="2" :xl="2">
				<div class="title">
					下班时间
				</div>
			</el-col>
			<el-col :xs="17" :sm="10" :md="10" :lg="10" :xl="10">
				<div class="block">
					<el-time-picker v-model="data.endTime" format="HH:mm" value-format="HH:mm">
					</el-time-picker>
				</div>
			</el-col>
		</el-row>

		<el-row type="flex" class="row-bg row-bg-1" justify="center">
			<el-col :xs="7" :sm="2" :md="2" :lg="2" :xl="2">
				<div class="title">
					休息时间扣除
				</div>
			</el-col>
			<el-col :xs="17" :sm="10" :md="10" :lg="10" :xl="10">
				<div class="block">
					<el-input-number v-model="data.restHour" :step="0.1" :min="0"></el-input-number>
				</div>
			</el-col>
		</el-row>

		<el-row type="flex" class="row-bg row-bg-2 row-bg-1" justify="center">
			<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
				<el-button class="longbtn" type="primary" @click="submit">确定提交</el-button>
			</el-col>
		</el-row>

	</div>
</template>

<script>
	import {
		getWorkTime,
		setWorkTime
	} from "@/api/worktime"
	export default {
		data() {
			return {
				data: {
					startTime: null,
					endTime: null,
					restHour: null
				}
			}
		},
		methods: {
			submit() {
				let that = this;
				setWorkTime(this.data).then(res => {
					if (res.data.success) {
						getWorkTime().then(res => {
							that.data.startTime = res.data.startTime;
							that.data.endTime = res.data.endTime;
							that.data.restHour = res.data.restHour;
						})
						that.$message({
							type: 'success',
							message: res.data.msg
						});
					} else {
						that.$message({
							type: 'error',
							message: res.data.msg
						});
					}
				})
			}
		},
		mounted() {
			let that = this;
			getWorkTime().then(res => {
				that.data.startTime = res.data.startTime;
				that.data.endTime = res.data.endTime;
				that.data.restHour = res.data.restHour;
			})
		}
	}
</script>

<style scoped="scoped">
	.workingHours {
		padding: 0 20px;
		text-align: left;
	}

	.title {
		line-height: 40px;
		text-align: right;
		padding-right: 10px;
	}

	.row-bg-1 {
		margin-top: -10px;
	}

	.longbtn {
		width: 100%;
	}
</style>
